<div class="pc-text betslip-edit-bet__error-message" *ngIf="props$ | async as props" [class.is-empty]="!props.isVisible">
    <bs-betslip-edit-my-bet-notification *ngIf="props.isVisible" [notification]="props.notification"> </bs-betslip-edit-my-bet-notification>
</div>
